import Active from './Active/index.ts';
import Aligned from './Aligned/index.ts';
import Brand from './Brand/index.ts';
import Default from './Default/index.ts';
import FileType from './FileType/index.ts';
import Filled from './Filled/index.ts';
import RichTextEditor from './RichTextEditor/index.ts';

const Icons = {
  // Icons with active boolean state
  ...Active,
  // Icons with alignment prop (ex. chevron with top, bottom)
  ...Aligned,
  // Brand logos used to represent companies or platforms (e.g. Google, Meta, Microsoft)
  ...Brand,
  // Static icons with no additional props
  ...Default,
  // Icons with filled boolean state
  ...Filled,
  // Rich text editor action icons
  ...RichTextEditor,
  // File type icons
  ...FileType,
};

export { Active, Aligned, Brand, Default, Filled, RichTextEditor, FileType };

export default Icons;
